import { NodeModel } from '@minoru/react-dnd-treeview';
import { EmployeeNodeModel } from '../../models/groupedEmployee.model';
import {
    WorkshiftSchedulingModel,
    WorkshiftsListModel,
} from '../../models/workshifts/workshif-scheduling/workshiftSchedulingList.model';
import { getChildNodes, getDatesBetweenDates } from '../../utils';

type Props = {
    grid: any;
    treeEmployees: NodeModel[];
    startDate: string;
    endDate: string;
    workshiftShedulingList: WorkshiftsListModel;
    getWorkshiftScheduling: (
        date: string | number,
        employeeID: string | number,
        workshiftShedulingList: WorkshiftsListModel
    ) => WorkshiftSchedulingModel | undefined;
    saveExceptionalWorkshiftsScheduling: (
        workshiftIds: number[],
        startDate: string,
        endDate: string,
        selectedEmployees: EmployeeNodeModel[]
    ) => void;
};

export const controllerExceptionalWorkshiftModal = ({
    grid,
    treeEmployees,
    startDate,
    endDate,
    workshiftShedulingList,
    getWorkshiftScheduling,
    saveExceptionalWorkshiftsScheduling,
}: Props) => {
    let recoveredData = window.localStorage.getItem('selection-range');

    let row1 = grid.selectedRanges[0].row;
    let row2 = grid.selectedRanges[0].row2;
    let col1 = grid.selectedRanges[0].col - 2;
    let col2 = grid.selectedRanges[0].col2 - 2;

    if (row1 > row2) {
        let aux = row1;
        row1 = row2;
        row2 = aux;
    }

    if (col1 > col2) {
        let aux = col1;
        col1 = col2;
        col2 = aux;
    }

    let initDate = getDatesBetweenDates(startDate, endDate)[col1];
    let lastDate = getDatesBetweenDates(startDate, endDate)[col2];

    let selectedEmployees = getChildNodes(treeEmployees).slice(row1, row2 + 1);

    let dates = getDatesBetweenDates(initDate, lastDate);

    if (recoveredData) {
        let data: Array<{
            employeeId: string | number;
            text: string;
            date: string;
        }> = JSON.parse(recoveredData);
        if (data.length > 0) {
            let idsList: number[] = [];

            data.forEach((emp) => {
                let workshiftId = getWorkshiftScheduling(
                    emp.date,
                    emp.employeeId,
                    workshiftShedulingList
                )?.id;

                if (workshiftId) {
                    idsList.push(workshiftId);
                }
            });

            saveExceptionalWorkshiftsScheduling(
                idsList,
                startDate,
                endDate,
                treeEmployees
            );
        }
    } else {
        let workshiftsFloating: WorkshiftSchedulingModel[] | undefined = [];
        let workshiftIds: number[] = [];

        for (let emp = 0; emp < selectedEmployees.length; emp++) {
            for (let date = 0; date < dates.length; date++) {
                let workshiftId = getWorkshiftScheduling(
                    dates[date],
                    selectedEmployees[emp].id,
                    workshiftShedulingList
                );
                if (workshiftId?.workshift?.isFloating) {
                    workshiftsFloating.push(workshiftId);
                }
                if (workshiftId?.id) {
                    workshiftIds.push(workshiftId.id);
                }
            }
        }

        let existFloating = workshiftsFloating
            ?.map((w) => w.workshift?.isFloating)
            .includes(true);

        if (
            initDate &&
            lastDate &&
            selectedEmployees.length > 0 &&
            workshiftIds.length > 0 &&
            !existFloating
        ) {
            saveExceptionalWorkshiftsScheduling(
                workshiftIds,
                startDate,
                endDate,
                treeEmployees
            );
        }
    }
};
